module.exports = __webpack_public_path__ + "Formulario para Depósito Directo.pdf";